import axios from "@/axios";

/**
 * 🟢 تسجيل الدخول (Admin فقط)
 */
export async function login(data) {
    const response = await axios.post("/api/login", data);
    return response.data.user;
}

/**
 * 🟢 تسجيل الخروج
 */
export async function logout() {
    await axios.post("/api/logout");
}

/**
 * 🟢 جلب المستخدم الحالي (من الجلسة)
 */
export async function fetchMe() {
    const response = await axios.get("/api/user");
    return response.data;
}


/**
 * 🟢 جلب خطط الأدمن
 */
export async function fetchAdminPlans() {
    const response = await axios.get("/api/admin/plans");
    return response.data.plans;
}

/**
 * 🟢 إنشاء خطة جديدة (Admin)
 */
export async function createAdminPlan(data) {
    const response = await axios.post("/api/admin/plans", data);
    return response.data.plan;
}

/**
 * 🟢 تحديث خطة (Admin)
 */
export async function updateAdminPlan(id, data) {
    const response = await axios.put(`/api/admin/plans/${id}`, data);
    return response.data.plan;
}

/**
 * 🟢 حذف خطة (Admin)
 */
export async function deleteAdminPlan(id) {
    const response = await axios.delete(`/api/admin/plans/${id}`);
    return response.data;
}


/**
 * 🟢 جلب FAQ الأدمن
 */
export async function fetchAdminFaqs() {
    const response = await axios.get("/api/admin/faqs");
    return response.data.faqs;
}

/**
 * 🟢 إنشاء FAQ جديد (Admin)
 */
export async function createAdminFaq(data) {
    const response = await axios.post("/api/admin/faqs", data);
    return response.data.faq;
}

/**
 * 🟢 تحديث FAQ (Admin)
 */
export async function updateAdminFaq(id, data) {
    const response = await axios.put(`/api/admin/faqs/${id}`, data);
    return response.data.faq;
}

/**
 * 🟢 حذف FAQ (Admin)
 */
export async function deleteAdminFaq(id) {
    const response = await axios.delete(`/api/admin/faqs/${id}`);
    return response.data;
}


/**
 * 🟢 جلب بيانات صفحة الهبوط (Public)
 * - الأكاديميات (اسم + صورة)
 * - الخطط العامة (Admin)
 * - الأسئلة الشائعة (Admin)
 */
export async function fetchLandingData() {
    const response = await axios.get("/api/landing");
    return response.data;
}


/**
 * 🟢 جلب ميزات الذكاء الاصطناعي (Admin)
 */
export async function fetchAiFeatures() {
    const res = await axios.get("/api/admin/ai-features");
    return res.data.features;
}

/**
 * 🟢 إنشاء ميزة جديدة
 */
export async function createAiFeature(data) {
    const res = await axios.post("/api/admin/ai-features", data);
    return res.data.feature;
}

/**
 * 🟢 حذف ميزة
 */
export async function deleteAiFeature(id) {
    await axios.delete(`/api/admin/ai-features/${id}`);
}

/**
 * 🟢 جلب آراء العملاء (Admin)
 */
export async function fetchTestimonials() {
    const response = await axios.get("/api/admin/testimonials");
    return response.data.testimonials;
}

/**
 * 🟢 إنشاء رأي عميل جديد (Admin)
 */
export async function createTestimonial(data) {
    const response = await axios.post("/api/admin/testimonials", data);
    return response.data.testimonial;
}

/**
 * 🟢 تحديث رأي عميل (Admin)
 */
export async function updateTestimonial(id, data) {
    const response = await axios.put(`/api/admin/testimonials/${id}`, data);
    return response.data.testimonial;
}

/**
 * 🟢 حذف رأي عميل (Admin)
 */
export async function deleteTestimonial(id) {
    await axios.delete(`/api/admin/testimonials/${id}`);
}


// ================= Contacts (Admin) =================
export async function fetchAdminContacts() {
  const res = await axios.get("/api/admin/contacts");
  return res.data.contacts;
}

export async function createAdminContact(data) {
  const res = await axios.post("/api/admin/contacts", data);
  return res.data;
}

export async function updateAdminContact(id, data) {
  const res = await axios.put(`/api/admin/contacts/${id}`, data);
  return res.data;
}

export async function deleteAdminContact(id) {
  await axios.delete(`/api/admin/contacts/${id}`);
}
